import { useContext, useEffect, useRef } from "react";
import globalStates from "../../utils/global";
import "./HomeScreen1.css"
import { ImgHomeBox1, ImgHomeBox2, ImgHomeBox2b, ImgHomeBox3, ImgHomeBox3b, ImgHomeBox4 } from "../../assets";

const HomeScreen1 = () =>{

    const context = globalStates && globalStates.globalContext;
    const globalContext:any = useContext(context);
    const windowWidthClass = globalContext && globalContext.windowWidthClass;
    
    // const businessDetailImagesImg = businessDetailImages && businessDetailImages.screenBannerImg;

    const screenWebsiteRef = useRef(null) as any;
    // console.log({})
    useEffect(()=>{
        const handleScroll =()=>{
            const setScreensOffset = globalContext && globalContext.setScreensOffset;
            const screenWebsite = screenWebsiteRef.current.getBoundingClientRect();
            const top = screenWebsite.top;
            const bottom = screenWebsite.bottom;
            const offset = globalContext && globalContext.windowHeight;
            setScreensOffset((prev:any)=>{return {...prev, 
                isOffsetscreenWebsite: false, bottom, offset, top
            }});
            if(top < (-1*0.005*offset) ){
                setScreensOffset((prev:any)=>{return {...prev, bottom, offset, top,
                    isOffsetscreenWebsite: true,
                }});
            };
        };
        window.addEventListener('scroll', handleScroll);
        return () => {
        window.removeEventListener('scroll', handleScroll);
        };
    }, [globalContext])

    const componentData = {
        background: {
            image: {
                src: "",
                alt: ""
            }
        },
        shield: {

        },
        content: {
            images: {
                box1: {
                    src: ImgHomeBox1,
                    alt: ""
                },
                box2: {
                    src: ImgHomeBox2b,
                    alt: ""
                },
                box3: {
                    src: ImgHomeBox3,
                    alt: ""
                },
                box3b: {
                    src: ImgHomeBox3b,
                    alt: ""
                },
                box4: {
                    src: ImgHomeBox4,
                    alt: ""
                }
            }
        }
    }
 
    return(
        <>
            <div 
            ref={screenWebsiteRef} 
            className={`${windowWidthClass}-home-screen-1 wrapper`}>

                <div className="background">
                    <div className="frame">
                        <img
                            alt = {componentData.background.image.alt}
                            src = {componentData.background.image.src}
                        />
                    </div>
                </div>
                <div className="shield">

                </div>
                <div className="content display grid">
                    <div className="item box-1">
                        <div className="frame">
                            <img
                                src={componentData.content.images.box1.src}
                                alt={componentData.content.images.box1.alt}
                             />
                        </div>
                        <div className="text-wrapper">
                            <h1>KUNO /ku-no/</h1>
                            <p>old or ancient. tempe is the ancient cultural food heritage from Indonesia since 1600s and have been people's affordable protein source ever since.</p>
                        </div>
                    </div>
                    <div className="item box-2">
                        <div className="frame">
                            <img
                                src={componentData.content.images.box2.src}
                                alt={componentData.content.images.box2.alt}
                             />
                        </div>
                    </div>
                    <div className="item box-3">
                        <div className="frame b">
                            <img
                                src={componentData.content.images.box3b.src}
                                alt={componentData.content.images.box3b.alt}
                             />
                        </div>
                         <div className="frame a">
                            <img
                                src={componentData.content.images.box3.src}
                                alt={componentData.content.images.box3.alt}
                             />
                        </div>
                    </div>
                    <div className="item box-4">
                        <div className="frame">
                            <img
                                src={componentData.content.images.box4.src}
                                alt={componentData.content.images.box4.alt}
                             />
                        </div>
                    </div>
                </div>

            </div>
        </>
        
    )
};

export default HomeScreen1;